module.exports = "/_next/static/images/kiyma_curry_menu-d5d8d4dac3716636924aaec32326cfd3.jpg";